import { Component, OnInit, Inject } from '@angular/core';
import PerfectScrollbar from 'perfect-scrollbar';
import { AuthService } from '../services/auth.service';
import { UserSessionService } from '../services/user-session.service';
import { ProjectService } from '../services/project.service';
import { PartnerService } from '../services/partner.service';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../models/user';
import { LibConfiguration } from '../lib-configuration';
import { LIB_CONFIG } from '../lib-configuration-token';
import { UserService } from '../services/user.service';
import { PopupService } from '../services/popup.service';
import { SelectProject } from '../popups/selectProject';
import { AddProject } from '../popups/addProject';
import { ToastrService } from 'ngx-toastr';
import { IRouteInfo } from '../models/common';

@Component({
  selector: 'app-sidebar-cmp',
  templateUrl: 'sidebar.component.html',
})
export class SidebarComponent implements OnInit {
  private ROUTES: IRouteInfo[] = this.config.routes;
  
  partnersAndProjects: any;
  public menuItemsExample: any[];
  currentUser: User;
  ps: any;
  sidebar_mini_active: boolean = false;

  constructor(
    public authService: AuthService,
    public userSessionService: UserSessionService,
    private userService: UserService,
    private projectService: ProjectService,
    private partnerService: PartnerService,
    private popupService: PopupService,
    private route: ActivatedRoute,
    private router: Router,
    @Inject(LIB_CONFIG) public config: LibConfiguration,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.currentUser = this.userSessionService.currentUser;
    this.menuItemsExample = this.ROUTES.filter(
      (menuItem) => menuItem.example === false
    );
    if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
      const elemSidebar = <HTMLElement>(
        document.querySelector('.sidebar .sidebar-wrapper')
      );
      this.ps = new PerfectScrollbar(elemSidebar);
    }
    const body = document.getElementsByTagName('body')[0];
    if (body.classList.contains('sidebar-mini')) {
      this.sidebar_mini_active = true;
    }

    this.partnersAndProjects = this.setPartnersAndProjects(
      this.currentUser.partnersAndProjects
    );
  }

  get isMobileMenu(): boolean {
    return window.innerWidth < 991;
  }

  get selected(): string {
    return `${localStorage.getItem('partner')}: ${localStorage.getItem('project')}`;
  }

  reload() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(['./'], { relativeTo: this.route });
  }

  selectProject(event: any) {
    const projectItem = this.findAncestor(event.target, 'LI');
    const project_id = projectItem.getAttribute('project-id');
    const partner_id = projectItem.getAttribute('partner-id');

    if (!project_id || !partner_id) {
      this.toastr.error(
        'Hiba a project vagy partner kiválasztása közben!'
      );
      return;
    }

    this.partnerService.select({ partner_id }).subscribe(
      () => {
        this.toastr.success('Partner sikeresen kiválasztva!');
        this.reload();
      },
      () => {
        this.toastr.error('Hiba a partner kiválasztása közben!');
      }
    );

    this.projectService.select({ project_id }).subscribe(
      () => {
        this.toastr.success('Projekt sikeresen kiválasztva!');
        this.reload();
      },
      () => {
        this.toastr.error('Hiba a project kiválasztása közben!');
      }
    );

    const selectedProject = this.partnersAndProjects.find(data => data[0] === partner_id);

    localStorage.setItem('partner', selectedProject[1]);
    localStorage.setItem('project', selectedProject[2].find(data => data[1] === project_id)[0]);
  }

  private findAncestor(el: any, tag: string) {
    while ((el = el.parentElement)) {
      if (el.tagName === tag) {
        return el;
      }
    }
  }

  setPartnersAndProjects(rawPartnersAndProjects: object) {
    const formattedData = [];
    for (const [partnerDetails, projects] of Object.entries(
      rawPartnersAndProjects
    )) {
      const partnerWithProjects: any = ['', '', []];

      const partnerId = this.getIdFromPartnersAndProjects(partnerDetails);
      const partnerName = this.getNameFromPartnersAndProjects(partnerDetails);

      partnerWithProjects[0] = partnerId;
      partnerWithProjects[1] = partnerName;

      if (projects.length > 0) {
        projects.forEach((rawProjectDetails) => {
          const projectId = this.getIdFromPartnersAndProjects(
            rawProjectDetails
          );
          const projectName = this.getNameFromPartnersAndProjects(
            rawProjectDetails
          );

          partnerWithProjects[2].push([projectName, projectId]);
        });
      }

      formattedData.push(partnerWithProjects);
    }

    return formattedData;
  }

  getIdFromPartnersAndProjects(rawData: string) {
    return rawData.substring(rawData.indexOf(':') + 1, rawData.indexOf(','));
  }

  getNameFromPartnersAndProjects(rawData: string) {
    return rawData.substring(rawData.lastIndexOf(':') + 1, rawData.length - 1);
  }

  minimizeSidebar(): void {
    const body = document.getElementsByTagName('body')[0];

    if (this.sidebar_mini_active) {
      body.classList.remove('sidebar-mini');
      this.sidebar_mini_active = false;
    } else {
      setTimeout(() => {
        body.classList.add('sidebar-mini');
        this.sidebar_mini_active = true;
      }, 300);
    }

    const simulateWindowResize = setInterval(() => {
      window.dispatchEvent(new Event('resize'));
    }, 180);

    setTimeout(() => {
      clearInterval(simulateWindowResize);
    }, 1000);
  }

  updatePS(): void {
    if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
      this.ps.update();
    }
  }

  isMac(): boolean {
    let bool = false;
    if (
      navigator.platform.toUpperCase().indexOf('MAC') >= 0 ||
      navigator.platform.toUpperCase().indexOf('IPAD') >= 0
    ) {
      bool = true;
    }
    return bool;
  }

  logout() {
    this.authService.logout();
  }

  viewProfile(): void {
    this.router.navigate(['/users/' + this.currentUser.id]);
  }

  async addProject() {
    // get partners to the popup list
    const { response } = await this.partnerService.getAll({}).toPromise();

    // get value from popup
    const newProjectData: any = await await this.popupService.fire(
      AddProject(response, this.popupService)
    );

    if (newProjectData.value) {
      try {
        // get partner and project id after project creation
        const projectCreationresponse = await this.projectService
          .add({
            project_data: JSON.stringify({ name: newProjectData.value.name }),
            partner_id: newProjectData.value.partnerId,
          })

          .toPromise();

        if (!projectCreationresponse) {
          throw new Error('Valami hiba történt!');
        }

        this.toastr.success('Új project sikeresen hozzáadva!');

        const loginNewProject = await this.popupService.fire(SelectProject());

        // select new project
        if (loginNewProject.value) {
          await this.projectService.select({
            project_id: projectCreationresponse.project_id,
          });
        }

        const userData = await this.userService.get().toPromise();

        this.userSessionService.setCurrentUser(
          userData.session,
          userData.response
        );

        this.reload();
      } catch (error) {
        this.toastr.error('Valami hiba történt!');
      }
    } else {
      this.toastr.warning('Művelet visszavonva!');
    }
  }
}
